import React, { useEffect } from 'react';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_MONITOR } from 'new/constants/pathnames';
import NotificationsManagerContainer from 'js/components/notificationsManager/NotificationsManagerContainer';
import { useDispatch } from 'react-redux';
import { setContextualSupport, unsetContextualSupport } from 'js/actions';
import { SUPPORT_KEY_NOTIFICATION } from 'js/constants/supportPageKeys';

interface NotificationSettingsProps {}

export const NotificationSettings: ScreenComponent<NotificationSettingsProps> = (
  props: NotificationSettingsProps,
) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setContextualSupport(SUPPORT_KEY_NOTIFICATION));

    return function cleanup() {
      dispatch(unsetContextualSupport(SUPPORT_KEY_NOTIFICATION));
    };
  }, []);

  // @ts-ignore
  return <NotificationsManagerContainer />;
};

NotificationSettings.screenConfig = {
  path: `${ROUTE_REDESIGN}${ROUTE_MONITOR}/notification-settings`,
  domain: 'monitor',
  header: {
    title: 'Notification Settings',
    slugTitle: 'Notification Settings',
  },
  screenName: 'NotificationSettings',
};
